/**
 * Route prefixes where anonymous users are allowed and auth bootstrap should be skipped.
 */
export const PUBLIC_AUTH_OPTIONAL_PATH_PREFIXES = ['/MKE-ERA', '/government-intake'] as const;

export function isPublicAuthOptionalPath(pathname: string): boolean {
  return PUBLIC_AUTH_OPTIONAL_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
